export { render, renderToDOM } from './render';
export { decorateStory as applyDecorators } from './decorateStory';
export var parameters = {
  framework: 'vue3'
};